import { Injectable, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import {
    BankAccountKycDialogResult,
    KycDialogVariant,
} from '../../components/app-layout/shared/bank-account-kyc-dialog/bank-account-kyc-dialog.component';

/**
 * Asks the KYC intro question for `FinancialConnectionsService`, which has no template of its own.
 * `app-bank-account-flow-dialogs-host` at the app root renders the dialog bound to `open`.
 */
@Injectable({ providedIn: 'root' })
export class BankAccountKycDialogStateService {
    readonly open = signal(false);
    readonly variant = signal(KycDialogVariant.BANK_ACCOUNT);

    private _result$: Subject<BankAccountKycDialogResult> | null = null;

    constructor(location: Location) {
        // Browser back/forward cancels, as MatDialog's closeOnNavigation did.
        location.subscribe(() => this.answer({ startVerification: false }));
    }

    ask(variant: KycDialogVariant = KycDialogVariant.BANK_ACCOUNT): Observable<BankAccountKycDialogResult> {
        this.answer({ startVerification: false });
        this._result$ = new Subject<BankAccountKycDialogResult>();
        this.variant.set(variant);
        this.open.set(true);

        return this._result$.asObservable();
    }

    answer(result: BankAccountKycDialogResult): void {
        const result$ = this._result$;
        this._result$ = null;
        this.open.set(false);
        result$?.next(result);
        result$?.complete();
    }
}
